import { render, staticRenderFns } from "./download-instagram-videos-without-account.vue?vue&type=template&id=99a06d38"
import script from "./download-instagram-videos-without-account.vue?vue&type=script&lang=js"
export * from "./download-instagram-videos-without-account.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports